module.exports = __webpack_public_path__ + "media/images/mobile-only/ptw-mobileonly-door-09ac8a5f23f681454e1ea9b4d7bdf25e.png";